<template>
  <div class="drawer-detail">
    <div class="field-type">
      <span class="label">项目沟通备注:</span>
      <div v-if="project.remark && project.remark.length > 0" class="context">
        <div v-for="(item, idx) in project.remark" :key="idx" class="remark-item">
          <div class="remark-item-title" style="margin-bottom:10px;font-size:14px;">
            <span style="margin-right:10px">{{ dateFormat(new Date(item.createAt), 'yyyy-mm-dd HH:MM') }}</span>
            <span>{{ item.user }}</span>
          </div>
          <div class="remark-item-content" style="font-size:14px;line-height:20px">
            <pre class="remark-content">{{ item.remark }}</pre>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const dateFormat = require('dateformat')

export default {
  props: {
    project: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      fields: ['remark'],
      translateTag: {
        remark: '项目沟通备注',
      },
    }
  },
  computed: {
    dateFormat() {
      return dateFormat
    },
  },
  methods: {},
}
</script>
<style scoped>
.flex {
  display: flex;
}
.value {
  background-color: #f2f2f2;
  padding: 10px;
}
</style>
<style src="../../constant/css/detail.css" scoped></style>
